import { render, staticRenderFns } from "./mails-list.vue?vue&type=template&id=807b74e2&scoped=true&"
import script from "./mails-list.vue?vue&type=script&lang=js&"
export * from "./mails-list.vue?vue&type=script&lang=js&"
import style0 from "./mails-list.vue?vue&type=style&index=0&id=807b74e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807b74e2",
  null
  
)

export default component.exports